import React from 'react';

import comp from '../comp';
import Loader from '../widgets/Loader';
import { useAuthContext } from '../context/AuthContext';

const PublicView = comp(() => import('./Public'));
const PrivateView = comp(() => import('./App'));

/**
 * Renders login vs. authenticated app based on AuthProvider's status — the bootstrap/retry
 * logic itself lives in AuthProvider, not here.
 *
 * @returns {JSX.Element}
 */
function AppGate() {
  const { status } = useAuthContext();

  if (status === 'checking') {
    return <Loader message="Loading..." />;
  }

  return status === 'authenticated' ? <PrivateView /> : <PublicView />;
}

export default AppGate;
